import React from "react";
//import Sidebar from "../components/navigation/navigation";
import Form from "../components/form/form";
import ImageSlider from "../components/slider/slider";
import { SliderData } from "../components/slider/sliderData";
import h from "../styles.module.css";

export default function MainForm() {
  // const [toggle, setToggle] = useState(true);

  // const wrapper = {
  //   position: "absolute",
  //   top: "0",
  //   left: "0",
  //   width: "100%",
  //   height: "100%",
  //   paddingLeft: "2.5%",
  //   paddingRight: "2.5%",
  //   msOverflowStyle: "none",
  //   transition: "width 50ms, left 50ms, right 50ms",
  // };

  const wrapperActive = {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    paddingLeft: "2.5%",
    paddingRight: "2.5%",
    msOverflowStyle: "none",
    transition: "width 50ms, left 50ms, right 50ms",
  };

  return (
    <div className={h.container}>
      {/* <button className={h.burguer} onClick={() => setToggle(!toggle)}></button> */}
      {/* <Sidebar toggle={toggle} /> */}
      {/* <div style={toggle ? wrapper : wrapperActive}> */}
      <div style={wrapperActive}>
        <ImageSlider slides={SliderData} />
        <Form />
      </div>
    </div>
  );
}
